import { useState } from "react"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { TextAtom } from "../atoms/TextAtom"
import { IconAtom } from "../atoms/iconAtom"
import { icon } from "../functions/icons"
import { IconButton } from "../atoms/buttons"
import { Modal, ModalBody, ModalTitle } from "./modal"

export const SocialPreview = ({data,message, open}) => {
    const [activePreview, setActivePreview] = useState([])
    const [previewModal, setPreviewModal] = useState(false)
    return (
        <div style={{marginBottom: "1rem", height: "18rem", maxHeight: open ? "12rem" : "", overflow: "hidden", overflowY: "auto",backgroundColor:"#F7F7F7", padding:"0.5rem", width:"unset", marginLeft:"1rem", marginRight:"1rem",  borderRadius:"0.3rem"}}>
        <TextAtom style={{ fontWeight:"bold", fontSize:"0.8rem"}} title={"Voorbeeld van je bericht"}></TextAtom>
        <LinkedInPreview openModal={() => setPreviewModal(true)} message={message} data={data} />
        <LinkedinPreviewModal message={message} data={data} visible={previewModal} onClose={() => setPreviewModal(false)}/>
        </div>
    )
}

const LinkedinPreviewModal = ({ visible, onClose, data, message}) => {

    return (
           <Modal
            height={null}
            size={"large"}
            visible={visible}
            dismissable={onClose}
            content={
                <>
                    <ModalTitle hasXmark={true} dismissable={onClose} title="LinkedIn Post" />
                    <ModalBody
                        content={
                            <>
                                <VerticalLayout className="linkedin-post modal-view" style={{ margin: 0, height: "auto", transform: "scale(1)", width: "auto"}}>
                                    <LinkedInUser />
                                    <LinkedInBody message={message} data={data} />
                                    <LinkedInInteractionRow />
                                    <LinkedInActionRow />
                                </VerticalLayout>
                            </>
                        }
                    />
                </>
            }
        />
    )
}

const LinkedInPreview = ({data, message, openModal }) => {
    return (
        <VerticalLayout className="linkedin-post" style={{ margin: "0", height: "auto"}}>
            <LinkedInUser />
            <LinkedInBody message={message} data={data} />
            <LinkedInInteractionRow />
            <LinkedInActionRow />
            <IconButton onClick={openModal} className={"maximize-icon"} icon2={"maximize"} size={60} color={"primary-600"}/>
        </VerticalLayout>
    )
}

const LinkedInUser = ({ }) => {
    return (
        <HorizontalLayout style={{ justifyContent: 'center' }}>
            <LinkedInAvatar />
            <LinkedUser />
            <TimePost />
        </HorizontalLayout>
    )
}

const LinkedInAvatar = () => {
    return (
        <div class="linkedin-avatar" >
            <div class="big-circle-linkedin">

            </div>
            <div class="small-circle-linked">

            </div>
            <div class="linkedin-blue">

            </div>
        </div>)
}

const LinkedUser = ({ }) => {
    return (
        <VerticalLayout style={{ marginLeft: "1rem", justifyContent: "center" }}>
            <TextAtom title={"Laurens Stienissen"} style={{ fontWeight: "bold" }} />
            <TextAtom title={"Founder - Expligo"} />
            <TextAtom title={"Now"} />
        </VerticalLayout>
    )
}
const LinkedInInteractionRow = ({ }) => {
    return (
        <HorizontalLayout>
            <LinkedinLikes />
            <LinkedinComments />
        </HorizontalLayout>
    )
}

const TimePost = ({ }) => {
    return (
        <TextAtom />
    )
}

const LinkedinLikes = () => {
    return (
        <HorizontalLayout>
            <SmallAvatar />
            <TextAtom
                title={""}
            />
        </HorizontalLayout>
    )
}
const SmallAvatar = ({ }) => {
    return (
        <div class="small-linkedin-avatar">

        </div>
    )
}
const LinkedinComments = () => {
    return
}
const LinkedInActionRow = () => {
    return (
        <HorizontalLayout style={{justifyContent:"space-between", width:"unset", paddingLeft:"1.5rem", paddingRight:"1.5rem", borderTopWidth:"1px", borderTopStyle:"solid", paddingTop:"1rem", borderColor:"rgb(235, 235, 235)"}}>

            <LinkedInAction icon={"Like"} title={"Like"}/>
            <LinkedInAction icon={"Comment"} title={"Comment"}/>
            <LinkedInAction icon={"Share"} title={"Share"}/>
            <LinkedInAction icon={"send"} title={"Send"}/>
        </HorizontalLayout>


    )
}
const LinkedInAction = ({ icon, title }) => {
    return (
        <VerticalLayout style={{width:"unset", gap:"0.5rem", alignItems:"center", justifyContent:"center", padding:"0.2rem"}}>
            <IconAtom style={{alignItems:"center", justifyContent:"center", display:"flex"}} icon2={icon} />
            <TextAtom
                title={title}
            />
        </VerticalLayout>
    )
}
const LinkedInBody = ({data,message}) => {
    console.log('image',data)
    return (
        <VerticalLayout style={{padding:"0.5rem", paddingTop:"1.25rem", paddingBottom:"1.25rem", width:"unset", height:"unset"}}>
            <TextAtom
                style={{fontColor:"grey"}}
                title={message}
            />
            <LinkedinImage url={data?.image_url}/>

        </VerticalLayout>
    )
}

const LinkedinImage = ({url}) => {
    return(
        <img style={{width:"100%", height:"15rem", backgroundColor:"grey", marginRight:"1.25rem", marginTop:"1.25rem", objectFit:"cover"}} src={url}/>
    )
}